import React from "react";
import {
	Box,
	Grid,
	Typography,
	TextField,
	IconButton,
	Button,
	MenuItem,
} from "@mui/material";
import { alpha } from "@mui/system";
import { Add, Delete, DisplaySettings } from "@mui/icons-material";

const OPERATORS = [
	{ value: ">", label: ">" },
	{ value: "<", label: "<" },
	{ value: "=", label: "=" },
	{ value: ">=", label: "≥" },
	{ value: "<=", label: "≤" },
	{ value: "!=", label: "≠" },
];

const METRICS = [
	{ value: "latencia", label: "Latência (ms)" },
	{ value: "packetLoss", label: "Perda de Pacote (%)" },
	{ value: "disponibilidade", label: "Disponibilidade (%)" },
	{ value: "potencia", label: "Potência RX (dBm)" },
	{ value: "trafego", label: "Tráfego" },
];

export default function SlaRulesSection({
	theme,
	rules,
	handleAddRule,
	handleRemoveRule,
	handleRuleChange,
	selectedTypes = [],
}) {
	const hasCpe = selectedTypes.includes("CPE");
	const hasOnu = selectedTypes.includes("ONU");

	const filteredMetrics = METRICS.filter((m) => {
		if (hasCpe && hasOnu) return true;
		if (hasOnu) {
			return m.value === "potencia" || m.value === "disponibilidade";
		}
		if (hasCpe) {
			return m.value !== "potencia";
		}
		return true;
	});

	const handleValueChange = (rule, rawValue) => {
		const regex = /^-?\d*[.,]?\d*$/;
		if (!regex.test(rawValue)) return;

		if (rawValue !== "" && rawValue !== "-") {
			const numeric = parseFloat(rawValue.replace(",", "."));
			if (
				(rule.metric === "packetLoss" || rule.metric === "disponibilidade") &&
				numeric > 100
			)
				return;
		}

		handleRuleChange(rule.id, "value", rawValue);
	};

	return (
		<Box
			sx={{
				p: 2,
				bgcolor: theme.palette.background.paper,
				borderRadius: "12px",
				width: "100%",
				mb: 1,
			}}
		>
			{/* Cabeçalho */}
			<Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 1 }}>
				<Box
					sx={{
						backgroundColor: alpha(theme.palette.primary.main, 0.2),
						borderRadius: "10px",
						width: "35px",
						height: "35px",
						display: "flex",
						alignItems: "center",
						justifyContent: "center",
					}}
				>
					<DisplaySettings
						fontSize="small"
						sx={{
							color:
								theme.palette.mode === "dark"
									? theme.palette.primary.light
									: theme.palette.primary.dark,
						}}
					/>
				</Box>
				<Typography variant="h6" sx={{ fontWeight: "bold", fontSize: "16px" }}>
					Motor de Regras de Disponibilidade
				</Typography>
			</Box>

			{rules.map((rule) => (
				<Box
					key={rule.id}
					sx={{
						border: "1px solid",
						borderColor: theme.palette.divider,
						pb: 2,
						pl: 2,
						borderRadius: "12px",
						mt: 2,
					}}
				>
					<Grid container spacing={1} sx={{ mt: 1 }}>
						{/* Métrica */}
						<Grid item xs={12} sm={4}>
							<TextField
								select
								size="small"
								fullWidth
								value={rule.metric}
								onChange={(e) =>
									handleRuleChange(rule.id, "metric", e.target.value)
								}
								InputProps={{ sx: { borderRadius: "12px" } }}
							>
								{filteredMetrics
									.filter((m) => m.value === rule.metric || !rules.some((r) => r.metric === m.value))
									.map((m) => (
										<MenuItem key={m.value} value={m.value}>
											{m.label}
										</MenuItem>
									))}
							</TextField>
						</Grid>

						{/* Operador */}
						<Grid item xs={12} sm={4}>
							<TextField
								select
								size="small"
								fullWidth
								value={rule.operator}
								onChange={(e) =>
									handleRuleChange(rule.id, "operator", e.target.value)
								}
								InputProps={{ sx: { borderRadius: "12px" } }}
							>
								{OPERATORS.map((op) => (
									<MenuItem key={op.value} value={op.value}>
										{op.label}
									</MenuItem>
								))}
							</TextField>
						</Grid>

						{/* Valor */}
						<Grid item xs={12} sm={3}>
							<TextField
								size="small"
								fullWidth
								value={rule.value}
								onChange={(e) => handleValueChange(rule, e.target.value)}
								InputProps={{ sx: { borderRadius: "12px" } }}
							/>
						</Grid>

						{/* Remover */}
						<Grid item xs={12} sm={1}>
							<IconButton
								size="small"
								sx={{ mt: 0.5 }}
								onClick={() => handleRemoveRule?.(rule?.id)}
							>
								<Delete
									color="error"
									fontSize="small"
								/>
							</IconButton>
						</Grid>
					</Grid>
				</Box>
			))}

			<Grid item xs={12} sx={{ mt: 2 }}>
				<Button
					size="small"
					variant="outlined"
					startIcon={<Add />}
					onClick={handleAddRule}
					disabled={rules.length >= filteredMetrics.length}
					sx={{ width: "100%", borderRadius: "8px" }}
				>
					Adicionar Regra
				</Button>
			</Grid>
		</Box>
	);
}
